module.exports = __webpack_public_path__ + "img/help.e551f60c.png";